import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import "../../Sidebars/PostJob/JobDetails.css";
import { Briefcase, Calendar, MapPin, User, FileText } from "lucide-react";
import { getJobDetails } from "../CServices/CJobServies";
import DOMPurify from "dompurify";
import NormalAlert from "../../AlertComponent/NormalAlert";

const CJobDetails = () => {
  const { jobUID } = useParams();
  const navigate = useNavigate();
  const [jobDetails, setJobDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState(null);

  const handleBack = () => {
    navigate("/Consultant/Dashboard/All-Jobs");
  };

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await getJobDetails(jobUID);
        if (response) {
          setJobDetails(response.data.jobData[0]);
        }
      } catch (error) {
        const safeMessage =
          error?.response?.data?.message ||
          "Something went wrong. Please try again.";

        setAlert({
          type: "fail",
          message: safeMessage,
        });
      } finally {
        setLoading(false);
      }
    };

    if (jobUID) fetchDetails();
  }, [jobUID]);

  const formatIndianCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN").format(amount);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return dateStr.split(" ")[0];
  };

  if (loading) return <div>Loading job details...</div>;
  if (!jobDetails) return <div>No job details found.</div>;

  return (
    <>
      <div className="job-details-wrapper mt-5">
        <div
          className="glass-card animated mx-auto"
          style={{ "max-width": "900px" }}
        >
          <h2 className="role-title">{jobDetails.jobTitle}</h2>

          <div className="badge-row">
            <span className="badge green">
              Position Type: {jobDetails.positionType}
            </span>
            <span className="badge gray">{jobDetails.jobCategory}</span>
            <span className="badge blue">
              No. of Opening:{jobDetails.numberOfOpenings}
            </span>
          </div>

          <div className="section-title">
            <Briefcase className="me-2" /> Role Info
          </div>
          <div className="grid">
            <div className="field">
              <strong>Function:</strong> {jobDetails.function}
            </div>
            <div className="field">
              <strong>Department:</strong> {jobDetails.department}
            </div>
          </div>

          <div className="section-title">
            <MapPin className="me-2" /> Location
          </div>
          <div className="grid">
            <div className="field">
              <strong>Zone:</strong> {jobDetails.zone}
            </div>
            <div className="field">
              <strong>Job Location:</strong> {jobDetails.location}
            </div>
          </div>

          <div className="section-title">
            <Calendar className="me-2" /> Miscellaneous
          </div>
          <div className="grid">
            <div className="field">
              <strong>Offered Salary:</strong>{" "}
              {formatIndianCurrency(jobDetails.offeredSalary)}
            </div>
            <div className="field">
              <strong>Qualification:</strong> {jobDetails.minimumQualification}
            </div>
            <div className="field">
              <strong>Experience:</strong> {jobDetails.minimumExperience} years
            </div>
            <div className="field">
              <strong>Gender Preference:</strong> {jobDetails.genderPreference}
            </div>
            <div className="field">
              <strong>Requisition Date:</strong>{" "}
              {formatDate(jobDetails.requisitionDate)}
            </div>{" "}
          </div>

          <div className="section-title">
            <FileText className="me-2" /> Job Description
          </div>
          <div
            className="field mb-4 job-description"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(
                jobDetails.jobDescription || "No description provided."
              ),
            }}
          ></div>

          <div className="text-center mt-4">
            <button
              className="btn btn-outline-primary px-5 py-2"
              onClick={handleBack}
            >
              ← Back to Jobs
            </button>
            <Link
              to={`/Consultant/Dashboard/Send-Candidate/${jobUID}`}
              className="btn btn-outline-primary px-5 py-2 mx-3"
              // onClick={handleShowCandidateForm(job.jobUID)}
            >
              Submit Candidate
            </Link>
          </div>
        </div>
      </div>
      {alert && (
        <NormalAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
};

export default CJobDetails;
